import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    buttonContainer: {
        flexDirection: 'row'
    },
    editButton: {
        minWidth: 0,
        flex: 1,
        margin: Theme.primaryMargin / 2,
        height: '70%',
        alignSelf: 'center'
    },
    editButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '24%',
        width: '100%',
        paddingHorizontal: Theme.primaryMargin,
        paddingVertical: 20
    }
};

export default StyleSheet.create(baseStyles);
